import {
  alchemyIntegrationLogo,
  argentIntegrationLogo,
  binanceIntegrationLogo,
  coinbaseIntegrationLogo,
  ethereumIntegrationLogo,
  infinityIntegrationLogo,
  ledgerIntegrationLogo,
  metamaskIntegrationLogo,
  polygonIntegrationLogo,
  rainbowIntegrationLogo,
  shopifyIntegrationLogo,
  stripeIntegrationLogo,
  trezorIntegrationLogo,
  trustWalletIntegrationLogo,
  unlockIntegrationLogo,
  walletConnectIntegrationLogo,
} from 'Assets/_Legacy/Integrations'

export const INTEGRATIONS = {
  ALCHEMY: {
    id: 'alchemyIntegration',
    logo: alchemyIntegrationLogo,
  },
  ARGENT: {
    id: 'argentIntegration',
    logo: argentIntegrationLogo,
  },
  BINANCE: {
    id: 'binanceIntegration',
    logo: binanceIntegrationLogo,
  },
  COINBASE: {
    id: 'coinbaseIntegration',
    logo: coinbaseIntegrationLogo,
  },
  ETHEREUM: {
    id: 'ethereumIntegration',
    logo: ethereumIntegrationLogo,
  },
  INFINITY: {
    id: 'infinityIntegration',
    logo: infinityIntegrationLogo,
  },
  LEDGER: {
    id: 'ledgerIntegration',
    logo: ledgerIntegrationLogo,
  },
  METAMASK: {
    id: 'metamaskIntegration',
    logo: metamaskIntegrationLogo,
  },
  POLYGON: {
    id: 'polygonIntegration',
    logo: polygonIntegrationLogo,
  },
  RAINBOW: {
    id: 'rainbowIntegration',
    logo: rainbowIntegrationLogo,
  },
  SHOPIFY: {
    id: 'shopifyIntegration',
    logo: shopifyIntegrationLogo,
  },
  STRIPE: {
    id: 'stripeIntegration',
    logo: stripeIntegrationLogo,
  },
  TREZOR: {
    id: 'trezorIntegration',
    logo: trezorIntegrationLogo,
  },
  TRUST_WALLET: {
    id: 'trustWalletIntegration',
    logo: trustWalletIntegrationLogo,
  },
  UNLOCK: { id: 'unlockIntegration', logo: unlockIntegrationLogo },
  WALLET_CONNECT: {
    id: 'walletConnectIntegration',
    logo: walletConnectIntegrationLogo,
  },
}
